module.exports = __webpack_public_path__ + "static/img/taxcellent_global_bg_h5.aad2515.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/taxcellent_global_bg_h5.png
// module id = 26hX
// module chunks = 34